import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconArrowDown: OSKIconDefinition = {
  name: 'arrow-down',
  content: '<path d="M12 5v14" /><path d="m19 12-7 7-7-7" />'
};
